import { Component, ElementRef, EventEmitter, Input, OnDestroy, OnInit, Optional, Output, ViewChild, } from '@angular/core';
import 'ag-grid-enterprise';
import { ApiService } from 'src/app/services/api.service';
import { FilterService } from 'src/app/services/filter.service';
import { Subscription } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { UnderScoreDetailsComponent } from '../payment-record-details/under-score-details.component';
import moment from 'moment';
import { CurrencyPipe } from '@angular/common';
import { AgRecordDetailsComponent } from '../../shared/ag-record-details/ag-record-details.component';
import { RowGroupingDisplayType } from 'ag-grid-enterprise';
import { ActivatedRoute } from '@angular/router';
import { ValueAsIconSnippetComponent } from '../../shared/value-as-icon-snippet/value-as-icon-snippet.component';
import { CustomChildGroupComponent } from '../../shared/custom-child-group/custom-child-group.component';
import { ValueBtnComponent } from '../basic-grid-list/value-btn.component';
import { CurrencyFormatGridComponent } from './formats/currency-grid-format.component';
import { PercentageFormatGridComponent } from './formats/percentage-grid-format.component';
import { EnhancementService } from 'src/app/services/enhancements-service';
import { PageDataService } from 'src/app/services/page-data.service';
import {
  DataAggregationService,
  AggregationConfig,
} from 'src/app/services/data-aggregation.service';
import _, { divide } from 'lodash';
import chroma from 'chroma-js';

import { CommentsGridComponent } from './comments-grid/comments-grid/comments-grid.component';
import { TimeFormatGridComponent } from './formats/time-grid-format.component';
import { StringConditionalComponent } from './formats/string-conditional-format.component';
import { BasicBarChartGridComponent } from 'src/app/components/shared/charts/hierarchical-custom-component/basic-bar-chart-grid.component';
@Component({
  selector: 'app-hierarchical-grid',
  templateUrl: './hierarchical-grid.component.html',
  styleUrls: ['./hierarchical-grid.component.scss']
})
export class HierarchicalGridComponent implements OnInit, OnDestroy {
  static key = 100608;

  @Input('item') item: any = {}
  @Input('pageKey') pageKey: any
  @Input('selectedHeader') selectedHeader: any

  @Output('onSizeChange') onSizeChange = new EventEmitter<any>();
  @ViewChild('paymentGridDiv', { static: true }) paymentGridDiv!: ElementRef;

  panelOpenState = false;
  iconList: any = []
  heading: any;
  config: any;
  childData: any = [];
  parentData: any = [];
  reqSubcription: Subscription[] = [];
  rowData: any = [];
  columnDefs: any[] = [];
  childColumnDefs: any = [];
  loader = true;
  selectedGroup: any;
  routerQueryParam: any = {};
  isDetailGrid: any;
  reportType: any;
  isPivotGrid: any;
  inputConfig: any = [] // comments var foe the input
  queryFilterData: any;
  isMaskCurrentQuarter = false;
  dividerVisibility = true;
  contextMenuCondition = true;
  error_name: any;

  detailRowAutoHeight = true;
  connectingCustomDetail = false;
  detailComponent:any = 'basicLineChartGridRenderer';

  public groupDisplayType: RowGroupingDisplayType = 'multipleColumns';

  dataPoints = 6;

  constructor(
    private filterService: FilterService,
    private apiService: ApiService,
    private httpClient: HttpClient,
    private currency: CurrencyPipe,
    private route: ActivatedRoute,
    private enhancementService: EnhancementService,
    @Optional() private pageDataService: PageDataService,
    private dataAgg: DataAggregationService,
  ) {
  }

  ngOnInit(): void {

    // Auto Height
    const observer = new ResizeObserver((e: any) => {
      this.onSizeChange.emit(e[0].contentRect.height);
    });
    observer.observe(this.paymentGridDiv.nativeElement);

    const cfg = this.item.config;
    if (cfg) {
      this.dataPoints = Number(cfg['data_points']) || 6;
    }

    let parentCfg = cfg['selected_column_parent'];
    let detailCfg = cfg['selected_column_detail'];
    this.reportType = cfg['defaultReportType'];
    this.isPivotGrid = cfg['isPivotGrid']?.name == 'true' ? true : false;

    this.selectedGroup = parentCfg.filter((flr: any) => flr.rowGroup);

    this.updateGroupDisplayType(cfg?.['rowGroupingDisplayType']?.name || 'singleColumn')
    this.isDetailGrid = cfg['connecting_detail_grid']?.name == 'Yes' ? true : false;
    this.isMaskCurrentQuarter = cfg['maskCurrentQuarter']?.name == 'Yes' ? true : false;
    this.dividerVisibility = cfg?.['dividerVisibility']?.name == 'No' ? false : true;
    this.contextMenuCondition = cfg?.['contextMenuCondition']?.name == 'No' ? false : true;
    this.detailRowAutoHeight = cfg?.['detailRowAutoHeight']?.name == 'No' ? false : true;
    this.connectingCustomDetail = cfg?.['connecting_custom_detail']?.name == 'Chart' ? true : false;
    this.detailComponent = cfg?.['detail_component']?.name || 'basicLineChartGridRenderer';

    if (cfg['connecting_detail_grid']?.name == 'Yes') {
      this.loadParentConfig(parentCfg);
      this.loadChildConfig(detailCfg, parentCfg);
    } else {
      this.loadParentConfig(parentCfg);
    }

    const dataMode = cfg?.['data_mode'] || 'widget'; // 'page' | 'widget'

    if (dataMode === 'widget') {
      // Widget mode: component fetches its own data independently
      this.reqSubcription.push(this.filterService.filterQuery.subscribe((query: any) => {
        this.loader = true;
        this.loadApiData();
      }));

      // Nested Widgets
      this.reqSubcription.push(
        this.filterService.triggerNestedQuery.subscribe((query: any) => {
          if (query == this.item.widget_uniq_key) {
            this.loader = true;
            this.loadApiData();
          }
        })
      );

      this.reqSubcription.push(
        this.filterService.treeMapSingleClickTrigger.subscribe((res: any) => {
          this.loader = true;
          this.loadApiData(res);
        })
      );

      this.reqSubcription.push(
        this.filterService.chroplethMapSelection.subscribe((res: any) => {
          this.loader = true;
          this.loadApiData(res);
        })
      );
    } else if (dataMode === 'page' && this.pageDataService) {
      // Page mode: data comes from centralized PageDataService
      this.reqSubcription.push(
        this.pageDataService.loading$.subscribe(loading => {
          if (loading) {
            this.loader = true;
          }
        })
      );

      const apiRaw = cfg?.['list_of_api_parent'] || cfg?.['list_of_api'];
      const apiKey = typeof apiRaw === 'string' || typeof apiRaw === 'number'
        ? apiRaw
        : apiRaw?.api_key;
      const stream$ = apiKey
        ? this.pageDataService.getDataStream(String(apiKey))
        : this.pageDataService.getCommonDataStream();

      this.reqSubcription.push(
        stream$.subscribe(res => {
          if (res && res.length > 0 && cfg) {
            this.applyPageData(res, cfg);
          }
        })
      );
    }
  }

  updateGroupDisplayType(newType: RowGroupingDisplayType) {
    this.groupDisplayType = newType;
  }

  // Parent Grid Configuration
  loadParentConfig(data: any) {

    this.columnDefs = [];
    // let ifChildGrouping = data.find((f:any)=> f.ifChildGrouping)

    // if(ifChildGrouping) {
    //   this.columnDefs.push({
    //     headerName: "SP",
    //     colId: "yearAthleteGroup",
    //     minWidth: 220,
    //     showRowGroup:  "ds_nm" ,
    //     cellRenderer: "agGroupCellRenderer",
    //     valueGetter: "data ? data.file_nm : null",
    //   })
    // }

    if (data.length) {
      data.forEach((res: any) => {
        res.property_CB.forEach((cb: any) => {
          if (cb.name == "Add Column") {
            if (cb.value) {
              var coldef: any = {
                headerName: res.api_resp_column_display_nm,
                field: res.api_resp_column_nm,
                colId: res.api_resp_column_nm,
                type: res.isDataType == 'integer' ? res.isFormats : res.isDataType,
                cellClass: res.headerVisiblity == 'No' ? 'cell-wrap-text-ffm-time-auto' : 'cell-wrap-text-h',
                autoHeight: true,
                selectedRowConfig: res,
                cacheQuickFilter: res.isFilter || false,
                menuTabs: res.isFilterMenu || [],
                sortable: res.isSortable || false,
                enableRowGroup: true,
                enableValue: true,
                pinned: res.pinnedColumn ? res.pinnedColumnPosition : '',
                isGroupHeader: res.isGroupHeader || false,
                GroupHeaderName: res.GroupHeaderName || null,
                minWidth: res.isMinWidth || 100
              };
              // debugger
              // console.log(res.isFilterMenu);

              if (res.ifChildGrouping) {
                this.columnDefs.push({
                  headerName: res.api_resp_column_display_nm,
                  colId: res.api_resp_column_nm + res.childGroupingName,
                  minWidth: res.isMinWidth,
                  autoHeight: true,
                  cacheQuickFilter: res.isFilter || false,
                  menuTabs: res.isFilterMenu || [],
                  sortable: res.isSortable || false,
                  showRowGroup: res.api_resp_column_nm,
                  // cellRenderer: "agGroupCellRenderer",
                  cellRenderer: CustomChildGroupComponent,
                  cellRendererParams: (params: any) => { return { 'configs': this.item.config, 'childGroupingName': res.childGroupingName } },
                  // valueGetter: "data ? data.file_nm : null",
                })
              }

              if (res.isHeaderConfiguration) {
                coldef["headerComponentParams"] = {
                  template: `
                        <div class="ag-cell-label-container" role="presentation">
                          <div ref="eLabel" class="ag-header-cell-label" role="presentation" style="display: ${res.headerVisiblity == 'No' ? 'none' : 'flex'};justify-content: ${res.isHeaderAlign || 'start'};text-align: ${res.isHeaderAlign || 'start'};padding-right: 5px;">
                              <span class="ag-header-cell-text" style="color: ${res.isHeaderColor || '#000'};">
                                ${res.api_resp_column_display_nm}
                              </span>
                              <span ref="eSortOrder" class="ag-header-icon ag-sort-order" ></span>
                              <span ref="eSortAsc" class="ag-header-icon ag-sort-ascending-icon" ></span>
                              <span ref="eSortDesc" class="ag-header-icon ag-sort-descending-icon" ></span>
                              <span ref="eSortNone" class="ag-header-icon ag-sort-none-icon" ></span>
                              <span ref="eFilter" class="ag-header-icon ag-filter-icon"></span>
                          </div>
                          <span ref="eMenu" class="ag-header-icon ag-header-cell-menu-button" style="position: absolute;margin: -5px;"></span>
                        </div>
                      `
                };
              }

              if (res.valueReplacingAsIcon) {
                coldef["cellRenderer"] = ValueAsIconSnippetComponent;
                coldef.cellRendererParams = (params: any) => {
                  return {
                    "conditionalFormat": this.item.config?.['iconConditionalFormat'],
                    "res": res
                  };
                };
              }

              if (res?.barChartVisiblity) {
                coldef["cellRenderer"] = BasicBarChartGridComponent;
                coldef.cellRendererParams = (params: any) => {
                  return {
                    barChartProperties: res?.['barChartProperties'] || [],
                    res: res
                  }
                };
              }

              if (res.isSortable && res.isSortableUsingOtherColumn) {
                coldef['comparator'] = (valueA: number, valueB: number, nodeA: any, nodeB: any, isDescending: any) => {
                  return nodeA['data'][res.sortableColumnName] - nodeB['data'][res.sortableColumnName]
                }
              }

              // Custom Sorting For Child Level
              let customSort = this.item.config?.['customSorting']?.name == 'Child Level';
              if (customSort) {
                coldef.comparator = (valueA: any, valueB: any, nodeA: any, nodeB: any, isInverted: boolean) => {
                  if (!nodeA && !nodeB) {
                    return 0
                  }
                  const isParentA = nodeA?.group && nodeA?.group === true;
                  const isParentB = nodeB?.group && nodeB?.group === true;

                  if (isParentA || isParentB) {
                    return 0;
                  } else {
                    if (typeof valueA === 'number' && typeof valueB === 'number') {
                      return valueA - valueB;
                    } else if (typeof valueA === 'string' && typeof valueB === 'string') {
                      if (res.isSortableUsingOtherColumn) return nodeA['data'][res.sortableColumnName] - nodeB['data'][res.sortableColumnName]
                      return valueA.localeCompare(valueB);
                    } else if (valueA instanceof Date && valueB instanceof Date) {
                      return valueA.getTime() - valueB.getTime();
                    } else {
                      return 0;
                    }
                  }
                };
              }

              if (res.GroupCellrenderer) {
                coldef['cellRenderer'] = 'agGroupCellRenderer'
              }
              if (res.CommentsCellrenderer) {
                coldef["cellRenderer"] = CommentsGridComponent
                coldef["cellRendererParams"] = (params: any) => ({
                  comments_length: res?.['comments_length'] || 250
                }),
                  this.inputConfig.push(res.api_resp_column_nm)
              }

              if (res.rowGroup) {
                coldef['rowGroup'] = true;
              }
              if (res.rowGroupHide) {
                coldef['hide'] = true;
              }

              if (res.isAggFunc) {
                coldef['aggFunc'] = res.isAggFuncSelection
              }

              if (res.removeUnderScore) {
                coldef["cellRenderer"] = UnderScoreDetailsComponent;
              }
              if (res.isEditable) {
                coldef["editable"] = true;
              } else {
                coldef["editable"] = false;

              }


              coldef["minWidth"] = res.isMinWidth || 80;

              // Alignment
              coldef['cellStyle'] = {
                'backgroundColor': res.isColumBgColor ? res.columnBgColor : '',
                'color': res.columTextColor || res.isTextColorCondition ? res.isTextColor : '#000',
                'font-weight' : res.text_fontweight ? res.text_fontweight : 'auto',
                'padding-right': '15px',
                textAlign: res.isAlignment ? res.isAlignment.toLowerCase() : ''
              }

              if (res.isTextColorConditionWithOpacity) {
                coldef['cellRenderer'] = 'myCellRenderer'
                coldef['cellRendererParams'] = (params: any) => {
                  return { res: res };
                };
              }

              // Data Types
              if (res.isDataType == "date") {
                let a = res.isPrefix || "";
                let b = res.issuffix || "";
                coldef["valueGetter"] = (params: any) => params.data?.[res.api_resp_column_nm] ? a + " " + moment(params.data[res.api_resp_column_nm]).format("MM/DD/YYYY") + " " + b : "";
              }

              if (res.isDataType == "time") {
                coldef["cellRenderer"] = TimeFormatGridComponent;
                // coldef["valueGetter"] = (params: any) => params.data?.[res.api_resp_column_nm] ? a + "" + this.helperService.convertMinutesToReadableFormat(params.data?.[res.api_resp_column_nm]) + "" + b : "";
              }

              // Integer
              if (res.isDataType == "integer") {
                let a = res.isPrefix || "";
                let b = res.issuffix || "";
                if (res.isFormats == 'Currency') {
                  coldef["cellRenderer"] = CurrencyFormatGridComponent;
                  coldef.valueGetter = (params: any) => (this.enhancementService.currentQuarterFlag && this.isMaskCurrentQuarter) ? '-' : params.data[res.api_resp_column_nm] ? params.data[res.api_resp_column_nm] : 0;
                  coldef.valueFormatter = (params: any) => (this.enhancementService.currentQuarterFlag && this.isMaskCurrentQuarter) ? '-' : params.value ? params.value : 0;
                  coldef.cellRendererParams = (params: any) => {
                    res['maskCurrentQuarter'] = this.isMaskCurrentQuarter;
                    return params['res'] = res;
                  };

                } else if (res.isFormats == 'Percentage') {
                  // if(!res.isConditionalFormat) { 
                  coldef["cellRenderer"] = PercentageFormatGridComponent;
                  coldef.valueGetter = (params: any) => (this.enhancementService.currentQuarterFlag && this.isMaskCurrentQuarter) ? '-' : ((params.data[res.api_resp_column_nm] != null) ? params.data[res.api_resp_column_nm] : '-');
                  coldef.valueFormatter = (params: any) => (this.enhancementService.currentQuarterFlag && this.isMaskCurrentQuarter) ? '-' : ((params.value = null) ? params.value! : '-');
                  coldef.cellRendererParams = (params: any) => {
                    res['maskCurrentQuarter'] = this.isMaskCurrentQuarter;
                    return params['res'] = res;
                  };
                  // } else {
                  //   coldef["valueFormatter"] = (params: any) => a + "" + params.value + "" + b;
                  // }
                } else {
                  // debugger
                  // coldef.valueGetter = (params: any) =>  a + "" + params.data[res.api_resp_column_nm] ? params.data[res.api_resp_column_nm] : 0 + "" + b;
                  coldef["valueFormatter"] = (params: any) => {
                    if (params.value == "-" || params.value == null) return "-";
                    if (isNaN(Number(params.value))) return a + "" + params.value + "" + b;
                    return a + "" + this.currency.transform(Number(params.value), "", "", "1.0-2") + "" + b;
                  };
                  coldef["comparator"] = (valueA: any, valueB: any) => {
                    const aIsEmpty = valueA == null || valueA === "-" || valueA === "";
                    const bIsEmpty = valueB == null || valueB === "-" || valueB === "";
                    if (aIsEmpty && bIsEmpty) return 0;
                    if (aIsEmpty) return -1;
                    if (bIsEmpty) return 1;
                    const numA = Number(valueA);
                    const numB = Number(valueB);
                    const aIsNum = !isNaN(numA);
                    const bIsNum = !isNaN(numB);
                    if (aIsNum && bIsNum) return numA - numB;
                    if (aIsNum) return 1;
                    if (bIsNum) return -1;
                    return String(valueA).localeCompare(String(valueB));
                  };
                }
              }

              // String for Init cap and upper and lower
              if (res.isDataType == "string") {
                let a = res.isPrefix || "";
                let b = res.issuffix || "";
                if (res.isTextCase == "from_db") {
                  coldef["valueFormatter"] = (params: any) => params.value ? a + "" + params.value + "" + b : "";
                } else if (res.isTextCase == "init") {
                  coldef["valueFormatter"] = (params: any) => params.value ? a + "" + params.value.toLowerCase().split(" ").map((s: any) => s.charAt(0).toUpperCase() + s.substring(1)).join(" ") + " " + b : "";
                } else if (res.isTextCase == "cap") {
                  coldef["valueFormatter"] = (params: any) => params.value ? a + "" + params.value.toUpperCase() + "" + b : "";
                } else {
                  coldef["valueFormatter"] = (params: any) => params.value ? a + "" + params.value.toLowerCase() + "" + b : "";
                }
                coldef["cellClass"] = "stringType";
              }

              if (res.isLinkingPage) {
                coldef.cellRenderer = AgRecordDetailsComponent;
                coldef.cellRendererParams = (params: any) => {
                  return {
                    type: res.isDataType,
                    item: this.item,
                    from: 'parent',
                    report_key: res.report_key,
                    detailChildApi: res.columnApi,
                    columnList: data,
                    linkingPageSelection: res.linkingPageSelection,
                    tabCount: res.tabCount,
                    columnConfig: res,
                    displayType: res.buttonNavigation ? 'button' : 'link',
                    style: res.buttonNavigation ? { color: this.getDataForconditionalStringColor(res.stringColorFormat, params, res.colorcolumn), 'padding-right': '15px', textAlign: res.isAlignment ? res.isAlignment.toLowerCase() : '' } : {}
                  };
                };
              }
              if (res.isConditionalFormat) {
                if (res.isConditionalTextColor == "backgroundColor") {
                  coldef["cellRendererFramework"] = ValueBtnComponent;
                  coldef["cellRendererParams"] = (params: any) => {
                    // debugger
                    if (this.rowData.length == 0) return;


                    if (res['isTypeOfFormat'] == 'typeOfString') {
                      return { color: this.getDataForStringColor(res.conditionalFormatForString, params, res), res: res, 'padding-right': '15px', textAlign: res.isAlignment ? res.isAlignment.toLowerCase() : '' }
                    } else {
                      const maxNumber = _.maxBy(this.rowData, (o: any) => o[res.api_resp_column_nm] || 0);
                      const colorCode = res['dynamicSelctColor'];
                      const divideBy = res['dataDividedBy'];

                      const dynamicRanges = this.getColorCode(maxNumber[res.api_resp_column_nm], Number(divideBy), colorCode, res);
                      if (res['logicsForColorCodes'] == 'dynamic') {
                        return { color: this.getDataColor(dynamicRanges, params), 'response': res, 'padding-right': '15px', textAlign: res.isAlignment ? res.isAlignment.toLowerCase() : '' }
                      } else {
                        return { color: this.getDataColor(res.conditionalFormat, params), 'padding-right': '15px', textAlign: res.isAlignment ? res.isAlignment.toLowerCase() : '' }
                      }
                    }
                  }
                } else {
                  if (res['isTypeOfFormat'] == 'typeOfString' && res['textWithBackgroundOpacityColor']) {
                    coldef.cellRenderer = StringConditionalComponent;
                    coldef.cellRendererParams = (params: any) => {
                      return { color: this.getDataForStringColor(res.conditionalFormatForString, params, res), 'background-color': this.getDataForBgColor(res, params), 'padding-right': '15px', textAlign: res.isAlignment ? res.isAlignment.toLowerCase() : '' }
                    };
                  } else {
                    coldef['cellStyle'] = (param: any) => {

                      if (this.rowData.length == 0) return;

                      if (res['isTypeOfFormat'] == 'typeOfString') {
                        return { color: this.getDataForStringColor(res.conditionalFormatForString, param, res), 'padding-right': '15px', textAlign: res.isAlignment ? res.isAlignment.toLowerCase() : '' }
                      } else {
                        const maxNumber = _.maxBy(this.rowData, (o: any) => o[res.api_resp_column_nm] || 0);
                        const colorCode = res['dynamicSelctColor'];
                        const divideBy = res['dataDividedBy'];

                        const dynamicRanges = this.getColorCode(maxNumber[res.api_resp_column_nm], Number(divideBy), colorCode, res);

                        if (res['logicsForColorCodes'] == 'dynamic') {
                          return { color: this.getDataColor(dynamicRanges, param), 'padding-right': '15px', textAlign: res.isAlignment ? res.isAlignment.toLowerCase() : '' }
                        } else {
                          return { color: this.getDataColor(res.conditionalFormat, param), 'padding-right': '15px', textAlign: res.isAlignment ? res.isAlignment.toLowerCase() : '' };
                        }
                      }

                    }
                  }
                }
              }

              this.columnDefs.push(coldef);
            }
          }
        })
      })

      this.columnDefs.push({
        headerName: 'Hidden Column',
        field: "hidden_column",
        hide: true,
        suppressPDFColumn: true,
        suppressColumnsToolPanel: true
      })
      if (this.columnDefs.find((f: any) => f.isGroupHeader == true)) {
        const groupedColumns = Object.values(
          this.columnDefs.reduce<Record<string, any>>((acc: any, col: any) => {
            if (col.isGroupHeader && col.GroupHeaderName) {
              const key = col.GroupHeaderName;
              if (!acc[key]) {
                acc[key] = {
                  headerName: key,
                  headerClass: `DU-Ag-grid-header-group`,
                  marryChildren: true,
                  children: [],
                };
              }
              acc[key].children.push(col);
            } else {
              // For fields not marked as group header
              acc[col.field] = col;
            }
            return acc;
          }, {})
        );
        // console.log(' newColumn', groupedColumns);

        this.columnDefs = groupedColumns;
      }

    }


  }

  generateShades(color: string, numShades: number): string[] {
    // Include the base color and generate lighter shades
    return Array.from({ length: numShades + 1 }, (_, i) => {
      const brightnessFactor = i / (numShades - 3.8);
      return i === 0 ? color : chroma(color).brighten(brightnessFactor).hex();
    });
  }

  getDataForStringColor(rangeValue: any, param: any, res: any) {
    if (!rangeValue) return null;

    for (let idx in rangeValue) {
      let r = rangeValue[idx];
      let value = res.ColorlinkColumnCondition ? param.data?.[res.attachLinkColumn] : param.value
      if (value == r.value) {
        return r.color;
      }

    }
    return null;
  }
  getDataForconditionalStringColor(rangeValue: any, param: any, field: any) {
    if (!rangeValue) return null;

    for (let idx in rangeValue) {
      let r = rangeValue[idx];
      // need to change dynamiclly
      if (param.data[field] == r.value) {
        return r.color;
      }

    }
    return null;
  }
  getDataForBgColor(rangeValue: any, param: any) {
    // debugger
    // textWithBackgroundOpacityColor
    if (!rangeValue.textWithBackgroundOpacityColor) return '';

    let value = rangeValue.conditionalFormatForString;
    if (!value) return null;

    for (let idx in value) {
      let r = value[idx];

      if (param.value == r.value) {
        return chroma(r.color).alpha(0.3).css();
      }

    }
    return null;
  }

  getColorCode(maxNumber: any, divideBy: number, colorCode: any, res: any) {
    if (divideBy === 1) {
      return [{ from: 0.1, to: maxNumber, color: res['rangeColorDynamic'][0].color }];
    }

    const shades: any = [];
    if (res['rangeColorDynamic']?.length) {
      res['rangeColorDynamic'].forEach((f: any) => {
        shades.push(f.color);
      })
    }
    shades.reverse();

    const divide = Number(maxNumber) / divideBy;

    const dataWithColorCodes = Array.from({ length: divideBy }, (_, index) => {
      const from_value = index === 0 ? res['logicsForIncludesZero'] == 'yes' ? 0 : 0.001 : Number(((divide * index) + 0.01).toFixed(2));
      const to_value = Number((divide * (index + 1)).toFixed(2));
      return { from_value, to_value, color: shades[index] };
    });

    if (res['logicsForIncludesZero'] == 'no') {
      dataWithColorCodes.unshift({ from_value: 0, to_value: 0, color: res['dynamicSelctZeroColor'] })
    }

    return dataWithColorCodes;
  }

  getDataColor(rangeValue: any[], param: any): string | null {
    if (!rangeValue || !param) return null;

    const value = param.value?.value !== undefined ? param.value.value : param.value;

    for (let r of rangeValue) {
      if (r.from_value === '>') {
        // Handle special case: greater than a certain value
        if (value > parseFloat(r.to_value)) {
          return r.color;
        }
      } else {
        // Handle range: from_value to to_value
        const from = parseFloat(r.from_value);
        const to = parseFloat(r.to_value);

        if (value >= from && value <= to) {
          return r.color;
        }
      }
    }

    return null;
  }

  // Child Grid Configuration
  loadChildConfig(data: any, parentData: any) {

    let newData: any = [];
    const filter = parentData?.filter((f: any) => f.GroupCellrenderer);
    filter.map((m: any) => newData.push({ filterKey: m.filterKey, key: m.api_resp_column_nm }))

    let filerRouter: any = [];

    const filerRouterData = data?.filter((f: any) => f.isLinkingPage);
    filerRouterData.map((m: any) => filerRouter.push({ filterKey: m.filterKey, key: m.api_resp_column_nm }))

    if (data.length) {
      data.forEach((res: any) => {
        res.property_CB.forEach((cb: any) => {
          if (cb.name == "Add Column") {
            if (cb.value) {

              var coldef: any = {
                headerName: res.api_resp_column_display_nm,
                field: res.api_resp_column_nm,
                colId: res.api_resp_column_nm,
                type: res.isDataType == 'integer' ? res.isFormats : res.isDataType,
                cellClass: 'cell-wrap-text-h',
                autoHeight: true,
                cacheQuickFilter: res.isFilter || false,
                menuTabs: res.isFilterMenu || [],
                sortable: res.isSortable || false
              };

              if (res.isHeaderConfiguration) {
                coldef["headerComponentParams"] = {
                  template: `
                        <div class="ag-cell-label-container" role="presentation">
                          <div ref="eLabel" class="ag-header-cell-label" role="presentation" style="display: ${(res.headerVisiblity == 'No' ? 'none' : 'flex')};justify-content: ${res.isHeaderAlign || 'start'};text-align: ${res.isHeaderAlign || 'start'}">
                              <span class="ag-header-cell-text" style="color: ${res.isHeaderColor || '#000'}">
                                ${res.api_resp_column_display_nm}
                              </span>
                              <span ref="eSortOrder" class="ag-header-icon ag-sort-order" ></span>
                              <span ref="eSortAsc" class="ag-header-icon ag-sort-ascending-icon" ></span>
                              <span ref="eSortDesc" class="ag-header-icon ag-sort-descending-icon" ></span>
                              <span ref="eSortNone" class="ag-header-icon ag-sort-none-icon" ></span>
                              <span ref="eFilter" class="ag-header-icon ag-filter-icon"></span>
                          </div>
                          <span ref="eMenu" class="ag-header-icon ag-header-cell-menu-button" style="position: absolute;margin: -5px;"></span>
                        </div>
                      `
                };
              }

              if (res.removeUnderScore) {
                coldef["cellRenderer"] = UnderScoreDetailsComponent;
              }

              if (res.api_resp_column_nm == "processed_date") {
                coldef["valueFormatter"] = (params: any) => params.data?.[res.api_resp_column_nm] ? moment(params.data[res.api_resp_column_nm]).format("MM/DD/YYYY") + " " : "";
              }

              coldef["minWidth"] = res.isMinWidth || 80;

              // Alignment
              coldef['cellStyle'] = {
                'backgroundColor': res.isColumBgColor ? res.columnBgColor : '',
                'color': res.columTextColor || res.isTextColor || '#000',
                'font-weight' : res.text_fontweight ? res.text_fontweight : 'auto',
                'padding-right': '15px',
                textAlign: res.isAlignment ? res.isAlignment.toLowerCase() : ''
              }

              if (res.isTextColorConditionWithOpacity) {
                coldef['cellRenderer'] = 'myCellRenderer'
                coldef['cellRendererParams'] = (params: any) => {
                  return { res: res };
                };
              }

              // Data Types
              if (res.isDataType == "date") {
                let a = res.isPrefix || "";
                let b = res.issuffix || "";
                coldef["valueFormatter"] = (params: any) => params.data?.[res.api_resp_column_nm] ? a + " " + moment(params.data[res.api_resp_column_nm]).format("MM/DD/YYYY") + " " + b : "";
              }

              // Integer
              if (res.isDataType == "integer") {
                let a = res.isPrefix || "";
                let b = res.issuffix || "";
                coldef["valueFormatter"] = (params: any) => params.value == "-" ? params.value : (a + "" + this.currency.transform(Number(params.value), "", "", "1.0-2") + "" + b);
              }

              // String for Init cap and upper and lower
              if (res.isDataType == "string") {
                let a = res.isPrefix || "";
                let b = res.issuffix || "";
                if (res.isTextCase == "from_db") {
                  coldef["valueFormatter"] = (params: any) => params.value ? a + "" + params.value + "" + b : "";
                } else if (res.isTextCase == "init") {
                  coldef["valueFormatter"] = (params: any) => params.value ? a + "" + params.value.toLowerCase().split(" ").map((s: any) => s.charAt(0).toUpperCase() + s.substring(1)).join(" ") + "" + b : "";
                } else if (res.isTextCase == "cap") {
                  coldef["valueFormatter"] = (params: any) => params.value ? a + "" + params.value.toUpperCase() + "" + b : "";
                } else {
                  coldef["valueFormatter"] = (params: any) => params.value ? a + "" + params.value.toLowerCase() + "" + b : "";
                }
              }

              if (res.isLinkingPage) {
                coldef['cellRendererFramework'] = AgRecordDetailsComponent;
                coldef['cellRendererParams'] = (params: any) => {
                  params['type'] = res.isDataType;
                  params['item'] = this.item;
                  params['from'] = 'child';
                  params['filter'] = newData;
                  params['detailFilterKey'] = filerRouter;
                  return params;
                }
              }

              this.childColumnDefs.push(coldef);

            }
          }
        })
      })
    }
  }

  // API For Parent Data
  loadApiData(obj?: any) {

    this.parentData = [];
    this.childData = [];

    let parent = this.item.config["list_of_api_parent"] || {};

    if (this.filterService.isEmptyObject(this.filterService.baseQuery) == false) {
      let obj1: any = { "api_key": parent?.api_key || undefined }

      let query1 = Object.assign({}, this.filterService.baseQuery, obj1, this.routerQueryParam, obj)
      query1["report_typ"] = this.filterService.report_type || this.reportType;
      query1['module_key'] = this.apiService.getModuleKey();

      if (parent.api_key == 100190 || parent.api_key == 10019702) {
        if (this.enhancementService.currentQuarterFlag) {
          query1["table_nm_version"] = 'curr'
        } else {
          query1["table_nm_version"] = 'hist'
        }
      }

      let endpoint = this.item.config?.['widget_endpoint'] || this.item.config?.['list_of_api_endpoint']  || '';

      this.reqSubcription.push(
        this.httpClient.post(`${this.apiService.apiBaseUrl}/${endpoint || this.apiService.executionUrl}`, query1).subscribe((res: any) => {

          let resParentData: any = res == null ? [] : res;
          if (resParentData.length == 0) {
            this.rowData = [];
            this.loader = false;
          } else {
            if (this.item.config['connecting_detail_grid'].name == 'Yes' && !this.connectingCustomDetail) {
              this.childApiData(resParentData, obj);
            } else {
              this.rowData = resParentData;
              this.loader = false;
            }
          }
          let find_filter_key:any = 'source_nm';
          let flag_name = 'decomm_flg';
          this.error_name = this.filterService.getDecommLabel(res, query1, find_filter_key, flag_name);
        }, (err: any) => {
          // console.log('Payment Error Record Parent', err);
          this.rowData = [];
          this.loader = false;
          this.error_name = err?.error?.error?.message || err?.error?.message || err?.message || '';
        })
      )
    }
  }

  // API For Child Data
  childApiData(resParentData: any, obj: any) {
    let detail = this.item.config["list_of_api_detail"] || {};
    let obj2: any = { "api_key": detail?.api_key || undefined }

    let query2 = Object.assign({}, this.filterService.baseQuery, obj2, this.routerQueryParam, obj)
    query2["report_typ"] = this.filterService.report_type || this.reportType;
    if (detail.api_key == 10019703) {
      if (this.enhancementService.currentQuarterFlag) {
        query2["table_nm_version"] = 'curr'
      } else {
        query2["table_nm_version"] = 'hist'
      }
    }
    query2['module_key'] = this.apiService.getModuleKey();
    let endpoint = this.item.config?.['widget_endpoint'] || this.item.config?.['list_of_api_endpoint']  || '';

    this.reqSubcription.push(
      this.httpClient.post(`${this.apiService.apiBaseUrl}/${endpoint ? endpoint : this.apiService.executionUrl}`, query2).subscribe((res: any) => {
        let resChildData = res == null ? [] : res;
        if (resChildData.length == 0) {
          this.rowData = resParentData;
          this.loader = false;
        } else {
          this.getData(resParentData, resChildData)
        }
        // let find_filter_key:any = 'source_nm';
        // let flag_name = 'decomm_flg';
        // this.error_name = this.filterService.getDecommLabel(res, query2, find_filter_key, flag_name);
      }, (err: any) => {
        // console.log('Payment Error Record Child', err);
        this.rowData = resParentData;
        this.loader = false;
        this.error_name = err?.error?.error?.message || err?.error?.message || err?.message || '';
      })
    )
  }

  // Get Mergin reference
  getData(resParent: any, resChild: any) {

    resParent.forEach((parent: any) => {
      let condition: any = {};
      let string = '';
      // Construct the condition dynamically based on reference_column values
      this.item.config['reference_column'].forEach((column: any) => {
        condition[column.api_resp_column_nm] = parent[column.api_resp_column_nm];
      });

      let child = resChild.filter((child: any) => {
        // Check if all properties in the condition match with child object
        return Object.keys(condition).every(key => child[key] === condition[key]);
      });

      Object.assign(parent, { 'callRecords': [...child] });

      string = '';
      if (child.length > 0) {
        child.map((m: any) => {
          let Ovalue = Object.entries(m).map(([key, value]) => ({ key, value }));
          Ovalue.map((o: any) => string += o.value + ' ')
        })
      } else {
        string = '';
      }

      Object.assign(parent, { 'hidden_column': string });
    });

    setTimeout(() => {
      this.rowData = [...resParent];
      this.loader = false;
    }, 200);
  }

  // ─── Page-mode data handling ────────────────────────────────────────────────

  private applyPageData(res: any[], cfg: any): void {
    if (cfg?.['AggregationEnabled'] === true) {
      const aggregated = this.aggregateCommonData(res);
      this.rowData = aggregated.rows;
    } else {
      this.rowData = res;
    }
    this.loader = false;
  }

  private aggregateCommonData(rows: any[]): { rows: any[] } {
    const cfg = this.item?.config || {};
    const aggCfg: AggregationConfig =
      (cfg['aggregation'] as AggregationConfig) || this.buildDefaultAggregationConfig(cfg);

    const result = this.dataAgg.aggregate(rows, aggCfg);

    return { rows: result.groups ? result.groups.map((g: any) => g.summary || g) : [result.summary] };
  }

  private resolveColName(cfg: any): string {
    const colRaw = cfg?.['kpi_1_value_api_col'] || cfg?.['kpi_value_api_col'];
    return typeof colRaw === 'string' ? colRaw : colRaw?.['api_resp_column_nm'] || '';
  }

  private buildDefaultAggregationConfig(cfg: any): AggregationConfig {
    return {
      groupBy: cfg['aggregation_groupBy'] || 'period',
      fields: cfg['aggregation_fields'] || {
        benefit_covered:     { source: 'benefit_covered',     op: 'sum' },
        total_bi_requests:   { source: 'total_bi_requests',   op: 'sum' },
        bi_tat_less_than_60: { source: 'bi_tat_less_than_60', op: 'sum' },
        total_patients:      { source: 'total_patients',      op: 'sum' },
        new_patients:        { source: 'new_patients',        op: 'sum' },
        total_pa_tat:        { source: 'total_pa_tat',        op: 'sum' },
        total_pa_tat_vol:    { source: 'total_pa_tat_vol',    op: 'sum' },
        pa_volume:           { source: 'pa_volume',           op: 'sum' },
        total_pa_required:   { source: 'total_pa_required',   op: 'sum' },
        pct_pa_request:      { source: 'pct_pa_request',      op: 'sum' },
      },
      computed: cfg['aggregation_computed'] || {
        bi_tat_pct: {
          op: 'percent',
          numerator: 'bi_tat_less_than_60',
          denominator: 'total_bi_requests',
          round: 2,
          suffix: this.resolveColName(cfg) === 'bi_tat_pct' ? '%' : undefined,
        },
        bi_covered_pct: {
          op: 'percent',
          numerator: 'benefit_covered',
          denominator: 'total_bi_requests',
          round: 2,
          suffix: this.resolveColName(cfg) === 'bi_covered_pct' ? '%' : undefined,
        },
        avg_bus_hours: {
          op: 'ratio',
          numerator: 'total_pa_tat',
          denominator: 'total_pa_tat_vol',
          round: 2,
          suffix: this.resolveColName(cfg) === 'pct_pa_request' ? 'h' : undefined,
        },
        pct_pa_request: {
          op: 'percent',
          numerator: 'total_pa_required',
          denominator: 'pa_volume',
          round: 2,
          suffix: this.resolveColName(cfg) === 'pct_pa_request' ? '%' : undefined,
        },
      },
      timeSeries: cfg['aggregation_timeSeries'] || {
        orderBy: 'period',
        limit: this.dataPoints,
        labelFormat: 'month',
        trackField: this.resolveColName(cfg) || 'total_patients',
      },
    };
  }

  ngOnDestroy(): void {
    this.reqSubcription.forEach((res) => res.unsubscribe());
  }
}








